import { Delta } from 'quill/core';
import { parseHeaderId } from '../formats/HeaderId';

const getHeaderTitle = (content: Delta, anchor: string): string | null => {
  const anchorHeaderId = parseHeaderId(anchor);
  let title: string | null = null;
  if (anchorHeaderId) {
    new Delta(content).eachLine((line, attributes) => {
      if (attributes.header && attributes['header-id'] === anchorHeaderId) {
        title = line
          .map((op) => (typeof op.insert === 'string' ? op.insert : ''))
          .join('');
        return false;
      }
      return true;
    });
  }
  return title;
};

export default getHeaderTitle;
